/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { Toggle } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function PfScoreView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: '20px 12px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
        {' '}
        <div style={{ flex: '1', minWidth: '260px' }}>
          {' '}
          <div style={{ fontSize: '17px', fontWeight: '500', letterSpacing: '-0.01em' }}>
            PointFive Score
          </div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
            {'A verified track record investors can read. '}
            <span style={{ color: 'var(--text2)', fontWeight: '600' }}>{dc.t(m.pfSubtitle)}</span>
            {' · weighted composite · public card you control.'}
          </div>{' '}
        </div>{' '}
        <button
          className="scp-4f3e86a"
          onClick={m.pfPreview}
          aria-label={dc.a(m.pfPreviewLabel)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '7px',
            fontSize: '11.5px',
            padding: '8px 15px',
            borderRadius: '99px',
            border: '1px solid var(--l12)',
            background: 'transparent',
            color: 'var(--text-mid)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-eye" style={{ fontSize: '13px' }}></i>
          {dc.t(m.pfPreviewLabel)}
        </button>{' '}
        <button
          className="scp-b722f2b"
          onClick={m.pfShareInvestor}
          aria-label="Share with investor"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '7px',
            fontSize: '11.5px',
            fontWeight: '500',
            padding: '8px 15px',
            borderRadius: '99px',
            border: '1px solid var(--l14)',
            background: 'var(--l6)',
            color: 'var(--text)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-share-network" style={{ fontSize: '13px' }}></i>Share with investor
        </button>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '18px',
          padding: '22px 24px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,380px),1fr))',
          gap: '24px',
        }}
      >
        {' '}
        <div style={{ minWidth: '0' }}>
          {' '}
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.13em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            {dc.t(m.pfMeta)}
          </div>{' '}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginTop: '6px' }}>
            {' '}
            <span
              style={{
                fontSize: '56px',
                fontWeight: '600',
                letterSpacing: '-0.04em',
                lineHeight: '1',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.pfScore)}
            </span>{' '}
            <span style={dc.css(`font-size:20px;font-weight:600;color:${dc.s(m.pfInk)};line-height:1.2`)}>
              {dc.t(m.pfGrade)}
            </span>{' '}
          </div>{' '}
          <div
            style={{
              fontSize: '11.5px',
              color: 'var(--muted)',
              marginTop: '8px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {dc.t(m.pfTierLine)}
          </div>{' '}
          <div style={{ marginTop: '16px' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
              <span
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.13em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                {dc.t(m.pfProgLabel)}
              </span>
              <div style={{ flex: '1' }}></div>
              <span style={{ fontSize: '10.5px', color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
                {dc.t(m.pfProgRatio)}
              </span>
            </div>{' '}
            <div
              style={{
                height: '6px',
                borderRadius: '99px',
                background: 'var(--l6)',
                marginTop: '7px',
                overflow: 'hidden',
              }}
            >
              <div
                style={dc.css(
                  `width:100%;height:100%;background:${dc.s(m.pfTone)};transform:scaleX(${dc.s(m.pfProgScale)});transform-origin:left center;transition:transform 260ms var(--ease-out)`,
                )}
              ></div>
            </div>{' '}
          </div>{' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginTop: '12px',
              fontSize: '10.5px',
              color: 'var(--muted)',
            }}
          >
            <span style={dc.css(`color:${dc.s(m.pfWeekDeltaFg)}`)}>
              {'↗ '}
              {dc.t(m.pfWeekDelta)}
            </span>
            <span style={{ color: 'var(--muted2)' }}>·</span>
            <span style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(m.pfSnapCount)}</span>
          </div>{' '}
          <div style={{ display: 'flex', gap: '36px', marginTop: '18px', flexWrap: 'wrap' }}>
            {' '}
            <div>
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.13em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Global rank
              </div>
              <div
                style={{
                  fontSize: '15px',
                  fontWeight: '600',
                  marginTop: '4px',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {dc.t(m.pfRank)}{' '}
                <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>{dc.t(m.pfRankOf)}</span>
              </div>
            </div>{' '}
            <div>
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.13em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Tier
              </div>
              <div style={dc.css(`font-size:13px;font-weight:500;color:${dc.s(m.pfInk)};margin-top:5px`)}>
                {dc.t(m.pfTierChip)}
              </div>
            </div>{' '}
            <div>
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.13em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Confidence
              </div>
              <div
                style={{
                  fontSize: '15px',
                  fontWeight: '600',
                  marginTop: '4px',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {dc.t(m.pfConfPct)}
              </div>
            </div>{' '}
          </div>{' '}
          {m.pfTierNote ? (
            <>
              {' '}
              <div style={{ fontSize: '10px', color: 'var(--muted2)', marginTop: '12px' }}>
                {'Raw tier: '}
                <span style={{ color: 'var(--amb-2)' }}>{dc.t(m.pfRawTier)}</span>
                {' · displayed as '}
                <span style={{ color: 'var(--text2)', fontWeight: '600' }}>{dc.t(m.pfDispTier)}</span>{' '}
                {dc.t(m.pfConfNote)}
              </div>{' '}
            </>
          ) : null}{' '}
        </div>{' '}
        <div style={{ minWidth: '0', display: 'flex', flexDirection: 'column' }}>
          {' '}
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.13em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            {dc.t(m.pfSnapCadence)}
          </div>{' '}
          <svg
            viewBox="0 0 560 96"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '150px', marginTop: '10px' }}
          >
            {' '}
            <line x1="0" y1="24" x2="560" y2="24" stroke="var(--l6)" strokeDasharray="3 5"></line>{' '}
            <line x1="0" y1="60" x2="560" y2="60" stroke="var(--l6)" strokeDasharray="3 5"></line>{' '}
            <defs>
              <linearGradient id="pfsnap" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor={dc.a(m.pfTone)} stopOpacity="0.26"></stop>
                <stop offset="1" stopColor={dc.a(m.pfTone)} stopOpacity="0"></stop>
              </linearGradient>
            </defs>{' '}
            <path d={dc.a(m.pfSnapFill)} fill="url(#pfsnap)"></path>{' '}
            <path
              d={dc.a(m.pfSnapPath)}
              fill="none"
              stroke={dc.a(m.pfTone)}
              strokeWidth="1.8"
              vectorEffect="non-scaling-stroke"
            ></path>{' '}
          </svg>{' '}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
            {' '}
            {(m.pfSnapLabels ?? []).map((s, i117) => (
              <Fragment key={i117}>
                <span
                  style={{ fontSize: '9.5px', color: 'var(--faint)', fontVariantNumeric: 'tabular-nums' }}
                >
                  {dc.t(s?.l)}
                </span>
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '18px',
          padding: '20px 24px',
        }}
      >
        {' '}
        <div
          style={{
            fontSize: '9px',
            letterSpacing: '0.13em',
            textTransform: 'uppercase',
            color: 'var(--muted2)',
            fontWeight: '600',
          }}
        >
          {dc.t(m.pfPillarHead)}
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,190px),1fr))',
            gap: '22px',
            marginTop: '18px',
          }}
        >
          {' '}
          {(m.pfPillarRow ?? []).map((p, i118) => (
            <Fragment key={i118}>
              {' '}
              <div style={{ minWidth: '0' }}>
                {' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  {dc.t(p?.label)}
                </div>{' '}
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '5px', marginTop: '6px' }}>
                  <span
                    style={{
                      fontSize: '26px',
                      fontWeight: '600',
                      letterSpacing: '-0.02em',
                      lineHeight: '1',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dc.t(p?.score)}
                  </span>
                  <span
                    style={{ fontSize: '11px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
                  >
                    {dc.t(p?.max)}
                  </span>
                </div>{' '}
                <div
                  style={{
                    height: '4px',
                    borderRadius: '99px',
                    background: 'var(--l6)',
                    marginTop: '10px',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={dc.css(
                      `width:${dc.s(p?.w)};height:100%;border-radius:99px;background:${dc.s(p?.bar)}`,
                    )}
                  ></div>
                </div>{' '}
                <div
                  style={{ fontSize: '10px', color: 'var(--muted2)', lineHeight: '1.5', marginTop: '9px' }}
                >
                  {dc.t(p?.metrics)}
                </div>{' '}
              </div>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,340px),1fr))',
          gap: '16px',
          alignItems: 'start',
        }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '18px',
            padding: '20px 22px',
          }}
        >
          {' '}
          <div style={{ fontSize: '13px', fontWeight: '500' }}>What moved your score</div>{' '}
          <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '3px' }}>
            Ranked by pillar impact
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '14px' }}>
            {' '}
            {(m.pfMoved ?? []).map((m, i119) => (
              <Fragment key={i119}>
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '14px',
                    padding: '14px 0',
                    borderBottom: '1px solid var(--l6)',
                  }}
                >
                  {' '}
                  <div style={{ flex: '1', minWidth: '0' }}>
                    <div style={{ fontSize: '12.5px', fontWeight: '500' }}>{dc.t(m?.title)}</div>
                    <div
                      style={{
                        fontSize: '10.5px',
                        color: 'var(--muted2)',
                        lineHeight: '1.5',
                        marginTop: '4px',
                      }}
                    >
                      {dc.t(m?.sub)}
                    </div>
                  </div>{' '}
                  <div style={{ textAlign: 'right', flex: 'none' }}>
                    <div
                      style={dc.css(
                        `font-size:13px;font-weight:600;color:${dc.s(m?.fg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(m?.v)}
                    </div>
                    <div style={{ fontSize: '9.5px', color: 'var(--muted2)' }}>impact</div>
                  </div>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '16px' }}>
            {' '}
            <span
              style={dc.css(
                `width:34px;height:34px;border-radius:50%;background:${dc.s(m.pfConfRingBg)};color:${dc.s(m.pfConfRingFg)};font-size:10px;font-weight:600;display:flex;align-items:center;justify-content:center;flex:none;font-variant-numeric:tabular-nums`,
              )}
            >
              {dc.t(m.pfConfPct)}
            </span>{' '}
            <div style={{ flex: '1', minWidth: '0' }}>
              <div style={{ fontSize: '11.5px', fontWeight: '500' }}>Score Confidence</div>
              <div
                style={{
                  fontSize: '10px',
                  color: 'var(--muted2)',
                  marginTop: '2px',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {dc.t(m.pfConfSub)}
              </div>
            </div>{' '}
            <span
              style={{
                fontSize: '11px',
                color: 'var(--pos)',
                fontVariantNumeric: 'tabular-nums',
                flex: 'none',
              }}
            >
              {dc.t(m.pfPnl)}
            </span>{' '}
            <span
              style={{
                fontSize: '11px',
                color: 'var(--muted)',
                fontVariantNumeric: 'tabular-nums',
                flex: 'none',
              }}
            >
              {dc.t(m.pfWr)}
            </span>{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '18px',
            padding: '20px 22px',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
            {' '}
            <div style={{ flex: '1', minWidth: '0' }}>
              <div style={{ fontSize: '13px', fontWeight: '500' }}>Investors viewing your card</div>
              <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '3px' }}>
                {dc.t(m.pfInvestorHead)}
              </div>
            </div>{' '}
            <button
              className="scp-4f3e86a"
              onClick={m.pfPrivacy}
              aria-label="Privacy settings"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '11px',
                padding: '6px 12px',
                borderRadius: '99px',
                border: '1px solid var(--l12)',
                background: 'transparent',
                color: 'var(--text-mid)',
                cursor: 'pointer',
                flex: 'none',
              }}
            >
              <i className="ph ph-lock-simple" style={{ fontSize: '12px' }}></i>Privacy settings
            </button>{' '}
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '14px' }}>
            {' '}
            {(m.pfInvestors ?? []).map((i, i120) => (
              <Fragment key={i120}>
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px 0',
                    borderBottom: '1px solid var(--l6)',
                  }}
                >
                  {' '}
                  <span
                    style={{
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      background: 'var(--l6)',
                      color: 'var(--text-mid)',
                      fontSize: '10.5px',
                      fontWeight: '600',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flex: 'none',
                    }}
                  >
                    {dc.t(i?.initials)}
                  </span>{' '}
                  <div style={{ flex: '1', minWidth: '0' }}>
                    <div style={{ fontSize: '12px', fontWeight: '500' }}>{dc.t(i?.name)}</div>
                    <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                      {dc.t(i?.offer)}
                    </div>
                  </div>{' '}
                  <span
                    style={dc.css(
                      `font-size:9px;font-weight:600;letter-spacing:0.06em;padding:3px 8px;border-radius:6px;background:${dc.s(i?.badgeBg)};color:${dc.s(i?.badgeFg)};flex:none`,
                    )}
                  >
                    {dc.t(i?.badge)}
                  </span>{' '}
                  {i?.act ? (
                    <>
                      {' '}
                      <button
                        className="scp-4f3e86a"
                        onClick={m.pfReview}
                        aria-label={`Review offer from ${dc.s(i?.name)}`}
                        style={{
                          fontSize: '11px',
                          padding: '5px 13px',
                          borderRadius: '99px',
                          border: '1px solid var(--l12)',
                          background: 'transparent',
                          color: 'var(--text-mid)',
                          cursor: 'pointer',
                          flex: 'none',
                        }}
                      >
                        Review
                      </button>{' '}
                    </>
                  ) : null}{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
          <button
            className="scp-4f3e86a"
            onClick={m.pfMessageAll}
            aria-label="Message all investors"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              width: '100%',
              marginTop: '16px',
              padding: '11px',
              borderRadius: '11px',
              border: '1px solid var(--l10)',
              background: 'transparent',
              color: 'var(--text-mid)',
              fontSize: '12px',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-chat-teardrop" style={{ fontSize: '13px' }}></i>Message all investors
          </button>{' '}
        </div>{' '}
      </div>{' '}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '8px' }}>
        {' '}
        <div>
          {' '}
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.13em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Public · external surface
          </div>{' '}
          <div style={{ fontSize: '15px', fontWeight: '500', letterSpacing: '-0.01em', marginTop: '7px' }}>
            Your Score, as investors see it.
          </div>{' '}
          <div
            style={{
              fontSize: '11.5px',
              color: 'var(--muted)',
              lineHeight: '1.65',
              marginTop: '8px',
              maxWidth: '70ch',
            }}
          >
            External-facing surfaces use the PointFive brand variant — aurora-on-dark, compound display type,
            capacity-first language. This is the canonical version of your card; you control which pillars and
            accounts to publish.
          </div>{' '}
        </div>{' '}
        <div
          style={{
            border: '1px solid var(--pub-line)',
            borderRadius: '18px',
            padding: '24px 26px',
            background: 'linear-gradient(135deg, var(--pub-a) 0%, var(--pub-b) 46%, var(--pub-c) 100%)',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,300px),1fr))',
            gap: '24px',
            alignItems: 'start',
          }}
        >
          {' '}
          <div style={{ minWidth: '0' }}>
            {' '}
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: 'var(--pub-dim)',
                fontWeight: '600',
              }}
            >
              {dc.t(m.pfVerified)}
            </div>{' '}
            <div
              style={{
                fontSize: '24px',
                fontWeight: '500',
                letterSpacing: '-0.02em',
                color: 'var(--pub-ink)',
                marginTop: '10px',
              }}
            >
              {dc.t(m.pfTraderName)}
            </div>{' '}
            <div style={{ fontSize: '14px', color: 'var(--pub-accent)', marginTop: '4px' }}>
              Verified Trader
            </div>{' '}
            <div
              style={{
                fontSize: '11.5px',
                color: 'var(--pub-dim)',
                lineHeight: '1.6',
                marginTop: '12px',
                maxWidth: '44ch',
              }}
            >
              {dc.t(m.pfPublicSub)}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,140px),1fr))',
                gap: '20px',
                marginTop: '20px',
                padding: '16px 18px',
                borderRadius: '14px',
                border: '1px solid var(--pub-line)',
                background: 'var(--pub-glass)',
              }}
            >
              {' '}
              <div>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--pub-dim)',
                    fontWeight: '600',
                  }}
                >
                  Composite P&L
                </div>
                <div
                  style={{
                    fontSize: '19px',
                    fontWeight: '500',
                    color: 'var(--pub-ink)',
                    marginTop: '6px',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.pfPublicPnl)}
                </div>
              </div>{' '}
              <div>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--pub-dim)',
                    fontWeight: '600',
                  }}
                >
                  Win rate
                </div>
                <div
                  style={{
                    fontSize: '19px',
                    fontWeight: '500',
                    color: 'var(--pub-ink)',
                    marginTop: '6px',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.pfPublicWr)}
                </div>
                <div
                  style={{
                    fontSize: '10px',
                    color: 'var(--pub-dim)',
                    marginTop: '2px',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.pfPublicWrSub)}
                </div>
              </div>{' '}
            </div>{' '}
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                fontSize: '10.5px',
                padding: '5px 13px',
                borderRadius: '99px',
                border: '1px solid color-mix(in srgb, var(--pub-accent) 40%, transparent)',
                background: 'color-mix(in srgb, var(--pub-accent) 14%, transparent)',
                color: 'var(--pub-accent)',
                marginTop: '20px',
              }}
            >
              {dc.t(m.pfTierChip)}
            </span>{' '}
          </div>{' '}
          <div style={{ minWidth: '0', textAlign: 'right' }}>
            {' '}
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: 'var(--pub-dim)',
                fontWeight: '600',
              }}
            >
              PointFive Score
            </div>{' '}
            <div
              style={{
                fontSize: '56px',
                fontWeight: '600',
                letterSpacing: '-0.04em',
                lineHeight: '1.05',
                color: 'var(--pub-accent)',
                marginTop: '6px',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.pfScore)}
            </div>{' '}
            <div style={{ fontSize: '14px', color: 'var(--pub-ink)', marginTop: '4px' }}>
              {dc.t(m.pfPublicGrade)}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                gap: '7px',
                justifyContent: 'flex-end',
                marginTop: '12px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              {(m.pfPublicChips ?? []).map((c, i121) => (
                <Fragment key={i121}>
                  <span
                    style={{
                      fontSize: '10px',
                      padding: '4px 11px',
                      borderRadius: '99px',
                      background: 'var(--pub-glass)',
                      border: '1px solid var(--pub-line)',
                      color: 'var(--pub-ink)',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dc.t(c?.label)}
                  </span>
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div style={{ fontSize: '10px', color: 'var(--pub-dim)', marginTop: '36px' }}>
              {dc.t(m.pfPublicSlug)}
            </div>{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '18px',
            padding: '18px 22px',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
            {' '}
            <i className="ph-fill ph-trophy" style={{ fontSize: '15px', color: 'var(--amb)' }}></i>{' '}
            <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Platform Leaderboard</span>{' '}
            <div style={{ flex: '1' }}></div>{' '}
            <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>Anonymised · This week</span>{' '}
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '14px' }}>
            {' '}
            {(m.pfBoardRows ?? []).map((e, i122) => (
              <Fragment key={i122}>
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px 16px',
                    borderRadius: '99px',
                    border: '1px solid color-mix(in srgb, var(--pos) 26%, transparent)',
                    background: 'color-mix(in srgb, var(--pos) 6%, transparent)',
                  }}
                >
                  {' '}
                  <i
                    className="ph-fill ph-crown-simple"
                    style={{ fontSize: '14px', color: 'var(--amb)', flex: 'none' }}
                  ></i>{' '}
                  <span style={{ fontSize: '12px', fontWeight: '500' }}>{dc.t(e?.name)}</span>{' '}
                  <span
                    style={{
                      fontSize: '9.5px',
                      padding: '2px 9px',
                      borderRadius: '99px',
                      border: '1px solid color-mix(in srgb, var(--sky-fill) 40%, transparent)',
                      color: 'var(--sky)',
                    }}
                  >
                    You
                  </span>{' '}
                  <div style={{ flex: '1' }}></div>{' '}
                  <span
                    style={dc.css(
                      `font-size:14px;font-weight:600;color:${dc.s(m.pfInk)};font-variant-numeric:tabular-nums`,
                    )}
                  >
                    {dc.t(e?.score)}
                  </span>{' '}
                  <span
                    style={{
                      fontSize: '9.5px',
                      fontWeight: '600',
                      letterSpacing: '0.06em',
                      padding: '3px 10px',
                      borderRadius: '99px',
                      background: 'color-mix(in srgb, var(--neg) 12%, transparent)',
                      color: 'var(--neg)',
                    }}
                  >
                    {dc.t(e?.tier)}
                  </span>{' '}
                  <span
                    style={{ fontSize: '11px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
                  >
                    {dc.t(e?.delta)}
                  </span>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginTop: '14px',
              paddingTop: '12px',
              borderTop: '1px solid var(--l6)',
            }}
          >
            {' '}
            <div style={{ flex: '1', minWidth: '0' }}>
              <div style={{ fontSize: '11.5px', fontWeight: '500' }}>Appear on the leaderboard</div>
              <div style={{ fontSize: '10px', color: 'var(--muted2)', marginTop: '2px' }}>
                Shows your display name, score and tier publicly. Reversible any time.
              </div>
            </div>{' '}
            <Toggle
              trackBg={m.pfOptTrack}
              knobBg={m.pfOptKnobBg}
              knob={m.pfOptKnob}
              onClick={m.pfOptInToggle}
              aria-label="Toggle leaderboard opt-in"
              aria-pressed={dc.b(m.pfOptIn)}
            />{' '}
          </div>{' '}
        </div>{' '}
      </div>
    </div>
  );
}
